import { NgModule } from '@angular/core';

// GraphQL
import { APOLLO_OPTIONS, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { ApolloClientOptions, InMemoryCache } from '@apollo/client/core';

// ENVs
import { environment as ENV } from '@environments/environment';



@NgModule({
  exports: [ ApolloModule ],
  providers: [
    {
      provide: APOLLO_OPTIONS,
      useFactory: GraphQLModule.createApollo,
      deps: [ HttpLink ]
    },
  ],
})
export class GraphQLModule {
  static createApollo(httpLink: HttpLink): ApolloClientOptions<any> {
    return {
      link: httpLink.create({ uri: `${ ENV.URI }${ ENV.URI_GRAPHQ }` }),
      cache: new InMemoryCache(),
    };
  }
}
